<div class="qcontainer">
  <app-questionnaire-answer
    *ngIf="showQuestionnaire && claimId && surveyId"
    [claimId]="claimId!"
    [questionnaireId]="surveyId!"
    (completed)="onComplete()"
  ></app-questionnaire-answer>
</div>
